import SeasonalOfferCarousel, { type SeasonalOfferCarouselProps } from './SeasonalOfferCarousel'

export default function ChaseTheSunOfferCarousel(props: SeasonalOfferCarouselProps) {
  return <SeasonalOfferCarousel {...props} category="longhaul" />
}
